import React from "react";
import { Grid, Box } from "@mui/material";
import { styled } from "@mui/material/styles";

const StyledGrid = styled(Grid)(({ theme }) => ({
  padding: "0 24px 12px 24px",
  marginBottom: theme.spacing(2),
}));

export interface IPageToolbarProps {
  enabled?: boolean;
  children?: React.ReactNode; // For additional content like buttons, sync icons, etc.
}

const PageTitle: React.FC<IPageToolbarProps> = ({ enabled, children }) => {
  return (
    <Box
      id="pageToolBar"
      sx={{
        pointerEvents: enabled ? "auto" : "none",
        opacity: enabled ? 1 : 0.5,
        transition: "opacity 0.2s",
        width: "100%",
      }}
    >
      <StyledGrid container className="page-header">
        <Grid
          id="pageToolBarGrid"
          container
          alignItems="center"
          justifyContent="space-between"
          sx={{ width: "100%" }}
        >
          {children}
        </Grid>
      </StyledGrid>
    </Box>
  );
};

export default PageTitle;
